export const MAX_MESSAGES_IN_STATE = 120;
export const LATEST_MESSAGES_UP_COUNT = 50;
export const MESSAGE_CONTEXT_UP_FOR_OLDER = 20;
export const MESSAGE_CONTEXT_DOWN_FOR_OLDER = 0;
export const MESSAGE_CONTEXT_UP_FOR_NEWER = 0;
export const MESSAGE_CONTEXT_DOWN_FOR_NEWER = 20;
export const MESSAGE_CONTEXT_DEFAULT_UP = 20;
export const MESSAGE_CONTEXT_DEFAULT_DOWN = 20;
export const MESSAGE_SCROLL_TOP_THRESHOLD = 80;
export const MESSAGE_SCROLL_BOTTOM_THRESHOLD = 80;
